import Vue from 'vue'
import { Bar, Line, Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins;

const getChart = (type) => {
	switch (type) {
		case 'line-chart':
			return Line;
		case 'bar-chart':
			return Bar;
		case 'pie-chart':
			return Pie;
		default:
			throw new Error("wrong chart type");
	}
};

const chartTypes = ['line-chart', 'bar-chart', 'pie-chart'];

//this makes registering all those components easier.
chartTypes.forEach(type => {
	Vue.component(type, {
		extends: getChart(type),
		mixins: [reactiveProp],
		props: ['options'],
		mounted() {
			this.renderChart(this.chartData, this.options)
		}
	})
});
export default {}